export default "__VITE_ASSET__RboZ_K5h__"